import NotificationsAPI from 'remote/notifications'
import { makesMutations } from 'data/graphql/hoc'

export default makesMutations({
  query: NotificationsAPI.requestChannelAccess,
  mutationPropName: 'requestChannelAccess',
})
